import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { motion } from 'framer-motion';

const useStyles = makeStyles(theme => ({
  listItem: {
    color: 'inherit!important',
    textDecoration: 'none!important',
    height: 40,
    width: '100%',
    borderRadius: 6,
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 8,
    '&.active': {
      backgroundColor:
        theme.palette.type === 'light'
          ? 'rgba(0, 0, 0, .05)!important'
          : 'rgba(255, 255, 255, .1)!important',
      pointerEvents: 'none',
      '& .list-item-icon': {
        color: 'inherit'
      }
    },
    '& .list-item-icon': {
      fontSize: 16,
      width: 16,
      height: 16,
      marginRight: 16
    }
  },
  listSubheader: {
    paddingLeft: 12
  }
}));

function CustomerSidebarContent({ customerId }) {
  const classes = useStyles();

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.4 } }}
      className="flex-auto border-l-1 border-solid">
      <div className="p-12">
        <List>
          <ListItem
            button
            component={NavLinkAdapter}
            to={`/customer-management/${customerId}/customer-detail`}
            activeClassName="active"
            className={classes.listItem}
            key="detail-info">
            <ListItemText primary="Müşteri Bilgileri" disableTypography />
          </ListItem>

          <ListItem
            button
            component={NavLinkAdapter}
            to={`/customer-management/${customerId}/customer-agreements`}
            activeClassName="active"
            className={classes.listItem}
            key="detail-approved-agreements">
            <ListItemText primary="Onaylanan Sözleşmeler" disableTypography />
          </ListItem>

          <ListItem
            button
            component={NavLinkAdapter}
            to={`/customer-management/${customerId}/customer-pharmacies`}
            activeClassName="active"
            className={classes.listItem}
            key="detail-pharmacies">
            <ListItemText primary="Kayıtlı Eczaneler" disableTypography />
          </ListItem>

          <ListItem
            button
            component={NavLinkAdapter}
            to={`/customer-management/${customerId}/customer-orders`}
            activeClassName="active"
            className={classes.listItem}
            key="detail-orders">
            <ListItemText primary="Siparişler" disableTypography />
          </ListItem>
        </List>
      </div>
    </motion.div>
  );
}

export default CustomerSidebarContent;
